var map = {
	"./": 75,
	"./development": 188,
	"./development.js": 188,
	"./index": 75,
	"./index.js": 75,
	"./production": 189,
	"./production.js": 189
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5759;


//////////////////
// WEBPACK FOOTER
// ./src/lib/config ^\.\/.*$
// module id = 5759
// module chunks = 0